// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"_60c410"};